import { useCallback, useEffect, useRef, useState } from 'react';
import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchGrants = () => {
  const [loading, setLoading] = useState();
  const [grants, setGrants] = useState([])
  const isMounted = useRef(true)

  const fetchAllLocations = useCallback(async () => {
    setLoading(true);
    if (grants.length === 0) {
      try {
        const response = await lineEndpoint.getGrants();
        if (response.status === 200) {
          if (isMounted.current) setGrants(response.data)
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllLocations().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllLocations]);

  return {
    loading,
    grants,
  };
};
